import { render, staticRenderFns } from "./OrderCmp.vue?vue&type=template&id=fb632e62&scoped=true"
import script from "./OrderCmp.vue?vue&type=script&lang=js"
export * from "./OrderCmp.vue?vue&type=script&lang=js"
import style0 from "./OrderCmp.vue?vue&type=style&index=0&id=fb632e62&lang=scss&scoped=true"
import style1 from "./OrderCmp.vue?vue&type=style&index=1&id=fb632e62&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb632e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb632e62')) {
      api.createRecord('fb632e62', component.options)
    } else {
      api.reload('fb632e62', component.options)
    }
    module.hot.accept("./OrderCmp.vue?vue&type=template&id=fb632e62&scoped=true", function () {
      api.rerender('fb632e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Add/OrderCmp.vue"
export default component.exports